module.exports = __webpack_public_path__ + "static/img/ZAK-JOHNSON.034198e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ZAK-JOHNSON.jpg
// module id = roXd
// module chunks = 0